import React from "react";
import { ButtonSingle } from "../../../../widget/common/form/Button";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import { ForwardChatContextImport } from "../../../../provider/chats/chats/forward_chat/ForwardChatContextProvider";

const ForwardChatButtons = (props: { isMedia: boolean }) => {
  const type: number = ResponsiveDeviceType();

  const { selectedProfiles, handleSend } = ForwardChatContextImport();

  return (
    <div className="text-center w-100">
      <ButtonSingle
        handleClick={() => handleSend(props.isMedia)}
        width={type === 3 ? 250 : undefined}
        disabled={selectedProfiles.length === 0}
      >
        {AppTranslation.text("send")}
      </ButtonSingle>
    </div>
  );
};

export default ForwardChatButtons;
